import React, { useState } from "react";
import PageLayout from "jadro-pico-app/Components/UI/Layouts/PageLayout/PageLayout";
import SectionCard from "jadro-pico-app/Components/UI/SectionCard/SectionCard";
import { SectionCardVariantEnum } from "jadro-pico-app/Components/UI/SectionCard/SectionCardVariantEnum";
import List from "jadro-pico-app/Components/UI/List/List";
import ListItem from "jadro-pico-app/Components/UI/List/ListItem/ListItem";
import Icon from "jadro-pico-app/Components/UI/Icon/Icon";
import ChlastLogo from "jadro-pico-app/Components/UI/ChlastLogo/ChlastLogo";
import { ThemeColorEnum, ThemeIconEnum } from "jadro-pico-app/Components/UI/Themes/ThemeEnums";
import { useResource } from "jadro-pico-app/Resources/useResource";
import { RequestQueueResources } from "jadro-pico-app/Resources/RequestQueueResources";
import { useRoutePaths } from "jadro-pico-app/Routes/useRoutePaths";
import { PicoComRoutes } from "jadro-pico-app/Routes/PicoComRoutes";
import { useNavigate } from "react-router";
import ProfileIdentity from "./ProfileIdentity";
import RacerProfileSection from "./RacerProfileSection";
import UserProfileSection from "./UserProfileSection";
import { CommonResources } from "../../Resources/CommonResources";
import { RacerProfileResources } from "../../Resources/RacerProfileResources";
import { UserProfileResources } from "../../Resources/UserProfileResources";

type ActiveSection = "beerrally" | "chlast" | null;

interface ProfileProps {
  onClose: () => void;
}

const Profile: React.FC<ProfileProps> = ({ onClose }) => {
  const common = useResource(CommonResources);
  const requestQueue = useResource(RequestQueueResources);
  const navigate = useNavigate();
  const paths = useRoutePaths(PicoComRoutes);
  const racer = useResource(RacerProfileResources);
  const user = useResource(UserProfileResources);
  const [activeSection, setActiveSection] = useState<ActiveSection>(null);

  if (activeSection === "beerrally") {
    return (
      <PageLayout maxWidth={720} gap={16} background={ThemeColorEnum.SURFACE_VARIANT}>
        <RacerProfileSection onCollapse={() => setActiveSection(null)} />
      </PageLayout>
    );
  }

  if (activeSection === "chlast") {
    return (
      <PageLayout maxWidth={720} gap={16} background={ThemeColorEnum.SURFACE_VARIANT}>
        <UserProfileSection onCollapse={() => setActiveSection(null)} />
      </PageLayout>
    );
  }

  return (
    <PageLayout maxWidth={720} gap={16} background={ThemeColorEnum.SURFACE_VARIANT}>
      <ProfileIdentity />

      <SectionCard variant={SectionCardVariantEnum.SURFACE} flush>
        <List dividers>
          <ListItem
            leadingElement={
              <Icon icon={ThemeIconEnum.SPORTS_BAR} color={ThemeColorEnum.ON_SURFACE} />
            }
            headline={racer.sectionTitle}
            onClick={() => setActiveSection("beerrally")}
          />
          <ListItem
            leadingElement={<ChlastLogo />}
            headline={user.sectionTitle}
            onClick={() => setActiveSection("chlast")}
          />
        </List>
      </SectionCard>

      <SectionCard variant={SectionCardVariantEnum.SURFACE} flush>
        <List>
          <ListItem
            leadingElement={
              <Icon icon={ThemeIconEnum.SCHEDULE} color={ThemeColorEnum.ON_SURFACE} />
            }
            headline={requestQueue.title}
            onClick={() => navigate(paths.REQUEST_QUEUE)}
          />
        </List>
      </SectionCard>

      <SectionCard variant={SectionCardVariantEnum.SURFACE} flush>
        <List>
          <ListItem
            leadingElement={<Icon icon={ThemeIconEnum.CLOSE} color={ThemeColorEnum.ON_SURFACE} />}
            headline={common.actionClose}
            onClick={onClose}
          />
        </List>
      </SectionCard>
    </PageLayout>
  );
};

export default Profile;
